// // In my bundle config this is setup to export to window.WaveSurfer
// import WaveSurfer from "wavesurfer.js";

import React from "react";
import ReactDOM from "react-dom";
import Timer from "../../components/Timer";

// import "wavesurfer.js";

import WaveSurfer from "wavesurfer.js";

export default class Waveform extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isPlaying: false ,sec:"00:29"};
  }
  componentDidMount() {
 
    this.$el = ReactDOM.findDOMNode(this);
    this.$waveform = this.$el.querySelector(".wave");
    this.wavesurfer = WaveSurfer.create({
      container: this.$waveform,
      waveColor: "#b5b5b5",
      barGap: 5,
      backgroundColor: "unset",
      barWidth: 5,
      barRadius: 5,
      responsive: true,
      
      progressColor: "#282828",
      fillParent: false,
      height: 50,
      minPxPerSec:window.innerWidth>480 ?480/44:window.innerWidth/44,
    });
    this.wavesurfer.load(this.props.src);
    this.wavesurfer.play(0, 100);
     
    // this.wavesurfer.minPxPerSec(1);
    
  }
  componentDidUpdate() {
  
  }
  componentWillUnmount() {}

  pause = () => {
    this.wavesurfer.pause();
    this.setState({ isPlaying: false });
  };
  play = () => {
    this.wavesurfer.play(this.wavesurfer.getCurrentTime());
    this.setState({ isPlaying: true });
    setInterval(() => {
      this.setState({sec:`00:${29-Math.round( this.wavesurfer.getCurrentTime())}`});
     }, 1000);
  };
  setFinish = () => {};
  render() {
    return (
      <div className="bg-white  waveform overflow-hidden d-flex align-items-center w-100 ">
        {/* <Timer setFinish={this.setFinish} time={32} /> */}
        <div>{this.state?.sec}</div>
        <div className="wave "></div>
        <div className=" d-flex ms-2">
          {this.state.isPlaying == true ? (
           <>
            <svg
              onClick={this.pause}
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="24" cy="24" r="24" fill="#0081F2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0983 14H21.3932C21.9972 14 22.4915 14.4942 22.4915 15.0983V32.671C22.4915 33.2751 21.9972 33.7693 21.3932 33.7693H18.0983C17.4942 33.7693 17 33.2751 17 32.671V15.0983C17 14.4942 17.4942 14 18.0983 14ZM26.8846 14H30.1795C30.7835 14 31.2778 14.4942 31.2778 15.0983V32.671C31.2778 33.2751 30.7835 33.7693 30.1795 33.7693H26.8846C26.2806 33.7693 25.7863 33.2751 25.7863 32.671V15.0983C25.7863 14.4942 26.2806 14 26.8846 14Z" fill="#FBFDFA"/>              
            </svg>
          
            </>
          ) : (
    
             
       
            <svg
              onClick={this.play}
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="24" cy="24" r="24" fill="#0081F2" />
              <path
                d="M21.0158 14.7447C19.5159 13.8624 17.625 14.9439 17.625 16.6841V31.3162C17.625 33.0564 19.5159 34.1379 21.0158 33.2556L33.4532 25.9395C34.932 25.0695 34.932 22.9308 33.4532 22.0608L21.0158 14.7447Z"
                fill="white"
              />
            </svg>
           
          )}
        </div>
      </div>
    );
  }
}

Waveform.defaultProps = {
  src: "/files/voice1.mp3",
};
